module.exports = __webpack_public_path__ + "static/media/president-site.70bf6d0d.png";